import {IconProps} from 'src/types/icon';

export const IconError = (props: IconProps): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" className={props.className} fill={props.fill || "currentColor"}>
    <path d="M3.757 2.343l9.899 9.899-1.414 1.414-9.899-9.899z" />
    <path d="M2.343 12.243l9.899-9.899 1.414 1.414-9.899 9.899z" />
  </svg>
);
